const minin = {
  data() {
    return {
      baseUrl: 'car',
      form: {},
      formCtrl: [
        {
          label: "车队长",
          keyName: "fleet",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
          // disabled: true,
        },
        {
          label: "车辆状态",
          keyName: "carstatus",
          type: "select",
          options: [
            {
              label: "在用",
              value: "在用"
            },
            {
              label: "停用",
              value: "停用"
            },
            {
              label: "报废",
              value: "报废"
            },
          ],
          className: "instyle",
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          className: "instyle",
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请选择司机",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
        },
        {
          label: "押运员姓名",
          keyName: "escort",
          err: "请选择押运员",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
        },
        {
          label: "挂车号",
          keyName: "trailer",
          err: "请选择挂车号",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
        },
        {
          label: "核定载重(吨)",
          keyName: "ton",
          err: "请填写核定载重",
          type: "number",
          className: "instyle",
        },
        {
          label: "超限比例",
          keyName: "overload",
          type: "select",
          options: [
            {
              label: '0',
              value: 0,
            },
            {
              label: '5%',
              value: 5,
            },
            {
              label: '10%',
              value: 10,
            },
            {
              label: '15%',
              value: 15,
            },
            {
              label: '20%',
              value: 20,
            },
            {
              label: '30%',
              value: 30,
            },
          ],
          className: "instyle",
        },
        {
          label: "车辆类型",
          keyName: "vtype",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
        },
        /*{
          label: "是否新车",
          keyName: "isnew",
          type: "select",
          options: [],
        },*/
        {
          label: "车辆购入时间",
          keyName: "buytime",
          err: "请选择车辆购入时间",
          type: "date",
          className: "instyle",
        },
        {
          label: "资产金额(元)",
          keyName: "asset",
          err: "请填写资产金额",
          type: "number",
          className: "instyle",
        },
        {
          label: "摊销年限(年)",
          keyName: "amortization",
          err: "请填写摊销年限",
          type: "number",
          className: "instyle",
        },
        {
          label: "定位设备号",
          keyName: "gps_number",
          err: "请填写定位设备号",
          type: "text",
          className: "instyle",
        },
        {
          label: "SIM卡号",
          keyName: "gps_sim_card",
          err: "请填写SIM卡号	",
          type: "text",
          className: "instyle",
        },
        {
          label: "到期时间",
          keyName: "gps_end_at",
          err: "请选择到期时间",
          type: "date",
          className: "instyle",
        },
        {
          label: "车辆照片",
          keyName: "car_image",
          type: "file",
          ptype: "car",
          tips: "最多上传10张图片",
          max: 10,
        },
      ],
      drivers: [],
      escorts: [],
      trailer_list: [],
    };
  },
  methods: {
    setFleet() {
      const {
        fleetid,
        fleetName
      } = this.$route.query;
      if (fleetid && fleetName != "null") {
        this.form.fleet = fleetid;
        this.formCtrl.map((v) => {
          if (v.keyName == "fleet") {
            v.options = [{
              label: fleetName,
              value: fleetid
            }];
          }
        });
      }
    },
    getOverload() {
      this.formCtrl.map((v) => {
        if (v.keyName == 'overload') {
          // console.log(v.options)
          if (!this.form.overload) this.form.overload = v.options[0].label
        }
      });
    },
    getKeys() {
      const arr = [
        'amortization',
        'asset',
        'buytime',
        'car_image',
        'carstatus',
        'driver',
        'driverid',
        'escort',
        'escortid',
        'fleet',
        'gps_end_at',
        'gps_number',
        'gps_sim_card',
        'id',
        'license',
        'overload',
        'ton',
        'trailer_id',
        'userid',
        'vtype',
      ]
      return arr
    },
    onChange({
      key,
      value
    }) {
      console.log(key, value)
      if (key === 'trailer') {
        if (!value) {
          this.$set(this.form, 'trailer_id', 0)
          this.$set(this.form, 'trailer', undefined)
          // console.log('form changed', { ...this.form });
          return
        }
        this.trailer_list.map((v) => {
          if (v.trailer == value) {
            this.$set(this.form, 'trailer_id', v.id)
            this.$set(this.form, 'trailer', v.trailer)
          }
        });
      } else if (key.includes("photo")) {
        const o = value.map((v) => {
          let result = v;
          if (v.response && v.response.photo) {
            result = {
              url: v.response.photo
            };
          }
          return result;
        });
        this.$set(this.form, key, o)
      } else if (["driver"].includes(key)) {
        this.$set(this.form, key, value)
        if (!value) {
          this.$set(this.form, 'driverid', 0)
          // console.log('form changed', { ...this.form });
          return
        }
        this.drivers.map((v) => {
          if (v.name == value) {
            this.$set(this.form, 'driverid', v.id)
          }
        });
      } else if (["escort"].includes(key)) {
        this.$set(this.form, key, value)
        if (!value) {
          this.$set(this.form, 'escortid', 0)
          // console.log('form changed', { ...this.form });
          return
        }
        this.escorts.map((v) => {
          if (v.name == value) {
            this.$set(this.form, 'escortid', v.id)
          }
        });
      } else {
        this.$set(this.form, key, value)
      }
      console.log('form changed', { ...this.form });
    },
    setDetail() {
      // 获取第一个表单所有字段名
      const keys = this.formCtrl.map((v) => {
        return v.keyName;
      });

      keys.map((key) => {
        const value = this.detail[key];
        if (["fleet"].includes(key)) {
          // this.$set(this.form, key, value + '')
        } else {
          this.$set(this.form, key, value)
        }
      });

      this.$set(this.form, 'driverid', this.detail['driverid'])
      this.$set(this.form, 'escortid', this.detail['escortid'])
      this.$set(this.form, 'trailer_id', this.detail['trailer_id'])

      this.$forceUpdate();

      // console.log('detail', { ...this.detail });
      // console.log('form', { ...this.form });
    },
    setOptions({
      carstatus,
      cartype,
      isnew,
      driver,
      escort,
      fleet,
      trailer_list,
    }) {
      // console.log(trailer_list)
      this.trailer_list = trailer_list;
      this.formCtrl.map((c) => {
        if (c.keyName == "trailer" && trailer_list && trailer_list.length) {
          this.trailerList = [...trailer_list]
          c.options = trailer_list.map((v) => {
            return {
              label: v.trailer,
              value: v.trailer,
            };
          });
        }
        if (c.keyName == "fleet" && fleet && fleet.length) {
          c.options = fleet.map((v) => {
            return {
              label: v.nickname,
              value: v.id,
            };
          });
          if (this.user.user_group_id == 5) {
            this.$set(this.form, c.keyName, this.user.id)
          }
        }
        if (c.keyName == "carstatus" && carstatus && carstatus.length) {
          c.options = carstatus.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          if (!this.form.license) this.form.carstatus = carstatus[0].name;
        }
        if (c.keyName == "driver" && driver && driver.length) {
          c.options = driver.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          this.drivers = driver
        }
        if (c.keyName == "escort" && escort && escort.length) {
          c.options = escort.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          this.escorts = escort
        }
        if (c.keyName == "vtype" && cartype && cartype.length) {
          c.options = cartype.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          //if (!this.form.license) this.form.vtype = cartype[0].name;
        }
        if (c.keyName == "isnew" && isnew) {
          for (const key in isnew) {
            if (Object.hasOwnProperty.call(isnew, key)) {
              const val = isnew[key];
              c.options.push({
                label: val,
                value: key,
              });
            }
          }
          this.form.isnew = "1";
        }
      });
      this.$forceUpdate();
      // console.log({ ...this.form })
    },
  },
  mounted() {
    // const { fleetid, id } = this.$route.query;
    // const params = {}
    // if (fleetid) params['fleetid'] = fleetid
    // if (id) params['car_id'] = id
    this.getOptions();
    this.setFleet();
    this.getOverload();
  },
}

export default minin